export interface IValue {
  Value: string;
  Error: string;
}

export interface ThirdPartyObject {
  Email: IValue;
  FirstName?: IValue;
  LastName?: IValue;
  PhoneNumber?: IValue;
}

export const isNotaryValid = (notary: ThirdPartyObject): boolean => {
  return areNotaryFieldsFilled(notary) && isNotaryWithoutErrors(notary);
};

export const areNotaryFieldsFilled = (notary: ThirdPartyObject): boolean => {
  return (
    notary.FirstName?.Value !== '' &&
    notary.LastName?.Value !== '' &&
    notary.PhoneNumber?.Value !== '' &&
    notary.Email?.Value !== ''
  );
};

export const isOneNotaryFieldFilled = (notary: ThirdPartyObject): boolean => {
  return (
    notary.FirstName?.Value !== '' ||
    notary.LastName?.Value !== '' ||
    notary.PhoneNumber?.Value !== '' ||
    notary.Email?.Value !== ''
  );
};

export const isNotaryWithoutErrors = (notary: ThirdPartyObject): boolean => {
  return (
    notary.Email?.Error === '' &&
    notary.FirstName?.Error === '' &&
    notary.LastName?.Error === '' &&
    notary.PhoneNumber?.Error === ''
  );
};
